import { useEffect, useState } from "react";
import axios from "axios";
import IndustrySendCollaborationRequestModal from "./IndustrySendCollaborationRequestModal";
const BASE_URL = process.env.REACT_APP_BASE_URL;
const IndustryProfiles = () => {
  const [profiles, setProfiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isOpen,setIsOpen] = useState(false)
  const [industry_id,setIndustryId] = useState(null)
  // console.log("The industry profiles are:",profiles)
  useEffect(() => {
    const fetchProfiles = async () => {
      try {
        const res = await axios.get(`${BASE_URL}/marketplace/industry/profiles/`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            "x-api-key": process.env.REACT_APP_X_API_KEY,
          },
        });

        setProfiles(res.data || []);
      } catch (error) {
        console.error("Error fetching industry profiles:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProfiles();
  }, []);

  if (loading) {
    return (
      <div className="text-center py-10 text-gray-500">
        Loading industry profiles...
      </div>
    );
  }

 const HandleSendCollobarationRequest = async (industry_id) => {
  if(!industry_id)
  {
     alert("Industry profile id required")
     return;
  }
  const confirm = window.confirm('Are you sure you want to send collaboration request?')
  if (confirm) {
    try {
      const response = await axios.post(
        `${BASE_URL}/marketplace/industry/collaboration/`,
        {
          industry:industry_id
        },  
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            "x-api-key": process.env.REACT_APP_X_API_KEY,
          },
        }
      )
      if(response.status === 201)
      {
        //  console.log("The response is:", response)
      alert('Collaboration request sent successfully!')
      }
    } catch (error) {
      alert(error.response.data.error)
      console.log("error while make collaboration", error)
    }
  }
}

  return (
 <>
  <div className="max-w-md mx-auto p-6">
  <h2 className="text-lg font-semibold text-gray-900 mb-1">Industry Profiles</h2>

<div className="flex flex-col gap-4">
  {profiles.map((profile, index) => (
    <div
      key={profile.id || index}
      className="bg-white rounded-2xl shadow-md p-5 border border-gray-100 hover:shadow-lg transition-all duration-200"
    >
      <div className="flex items-center gap-4 mb-5">
        <div className="w-16 h-16 rounded-xl overflow-hidden flex-shrink-0 border border-gray-200">
          <img
            src={profile?.industry_logo}
            alt={profile?.industry_name}
            className="w-full h-full object-cover"
          />
        </div>
        <div>
          <h3 className="text-lg font-semibold text-gray-900">{profile.industry_name}</h3>
          <p className="text-sm text-gray-500 mt-0.5">{profile.contact}</p>
          <p className="text-sm text-gray-500 mt-0.5">{profile.address?.slice(0, 40)}...</p>
        </div>
      </div>

      <button onClick={()=>{
        setIndustryId(profile?.id)
        setIsOpen(true)
      }} className="w-full px-5 py-2.5 bg-[#0f6abf] text-white rounded-xl hover:bg-[#0a5ca8] font-medium transition-all duration-200 flex items-center justify-center gap-2">
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
  </svg>
  Collaborate
</button>
    </div>
  ))}
</div>
</div>
<IndustrySendCollaborationRequestModal isOpen={isOpen} onClose={()=>setIsOpen(false)} industry_id={industry_id}/>
 </>
  );
};

export default IndustryProfiles;